import { TPaymentMethodType } from 'shared/domain/entities';

export const checkoutQueries = {
  base: ['checkout'] as const,

  budget: (id: number | undefined) =>
    [...checkoutQueries.base, 'budget', id] as const,

  cardInstallments: (
    budgetId: number | undefined,
    cardNumber: string | undefined,
    flag: string | undefined,
    method: TPaymentMethodType | undefined,
  ) =>
    [
      ...checkoutQueries.base,
      'cardInstallments',
      budgetId,
      cardNumber,
      flag,
      method,
    ] as const,

  automaticDebitInstallments: (budgetId: number | undefined) =>
    [...checkoutQueries.base, 'automaticDebitInstallments', budgetId] as const,

  citiesByName: (name: string | undefined) =>
    [...checkoutQueries.base, 'citiesByName', name] as const,

  districtsByCityAndName: (
    cityId: number | undefined,
    name: string | undefined,
  ) =>
    [...checkoutQueries.base, 'districtsByCityAndName', cityId, name] as const,

  budgetStatus: (budgetId: number | undefined) => [
    ...checkoutQueries.base,
    'budgetStatus',
    budgetId,
  ],
};
